// extracted by mini-css-extract-plugin
export default {"containprod":"qM","containprod2":"rM","title":"sM","servings":"tM","recommendation":"uM","image":"vM","flavorswrap":"wM","flavorsgroupwrap":"xM","moredetailsWrap":"yM","infoWrap":"zM","price":"AM","regularPrice":"BM","netPrice":"CM","addtocartcontainer":"EM","error":"FM"};
    if(module.hot) {
      // 1721922364833
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  